import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2AppleIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 20.087 24.002",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 24.002),
    children: [/*#__PURE__*/jsx("path", {
      d: "m10.044 22.274c1.467 0 .489.978 3.424.978s5.87-5.87 5.87-9.783-2.446-6.848-5.38-6.848-2.935.978-3.913.978-.978-.978-3.913-.978-5.38 2.935-5.38 6.848 2.935 9.783 5.87 9.783 1.954-.978 3.422-.978z"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.044 7.601v-1.957a1.962 1.962 0 0 0 -1.956-1.957h-1.957"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.614 5.075a4.4 4.4 0 0 0 3.746-3.745.506.506 0 0 0 -.572-.572 4.4 4.4 0 0 0 -3.742 3.745.5.5 0 0 0 .571.571z"
    })]
  });
};

export { PM2AppleIcon };
//# sourceMappingURL=apple.js.map
